import {
  GROUPS_FETCH,
  GROUP_CREATE,
  GROUP_ADD_TREES,
  GROUP_REMOVE_TREES,
  GROUP_DELETE,
} from '../actions';

const INIT_STATE = {
  list: [],
  current: null,
};

export default function groupsReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case GROUPS_FETCH.SUCCESS:
      return { ...state, list: action.payload };
    case GROUP_CREATE.SUCCESS:
      return { ...state, list: [...state.list, action.payload], current: action.payload };
    case GROUP_ADD_TREES.SUCCESS:
      return {
        ...state,
        list: state.list.map((g) => (g.group_id === action.payload.group_id ? action.payload : g)),
        current: action.payload,
      };
    case GROUP_REMOVE_TREES.SUCCESS: {
      if (action.payload.deleted) {
        return {
          ...state,
          list: state.list.filter((g) => g.group_id !== action.payload.group_id),
          current: state.current?.group_id === action.payload.group_id ? null : state.current,
        };
      }
      return {
        ...state,
        list: state.list.map((g) => (g.group_id === action.payload.group_id ? action.payload : g)),
        current: action.payload,
      };
    }
    case GROUP_DELETE.SUCCESS:
      return {
        ...state,
        list: state.list.filter((g) => g.group_id !== action.payload.group_id),
        current: state.current?.group_id === action.payload.group_id ? null : state.current,
      };
    default:
      return state;
  }
}
